import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  Textarea,
  useToast,
} from "@chakra-ui/react";

import CrmDataService from "../../services/data";
import { useState, useEffect } from "react";

export const NoteModal = ({ isOpen, onClose, id, func, existingNote }: any) => {
  const [note, setNote] = useState("");

  useEffect(() => {
    setNote(existingNote || "");
  }, [existingNote]);

  const toast = useToast();

  const handleDeleteNote = () => {
    const data = { note: "" };

    if (!id) {
      toast({
        position: "top",
        title: "User Id not found",
        status: "error",
        duration: 1500,
        isClosable: true,
      });
      return;
    }

    CrmDataService.updateCrmDataById(id, data)
      .then(() => {
        func();
        onClose();
        toast({
          position: "top",
          title: "Note Deleted Successfully",
          status: "success",
          duration: 1000,
          isClosable: true,
        });
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  const handleAddEditNote = () => {
    const data = { note };

    if (!id) {
      toast({
        position: "top",
        title: "User not found",
        status: "error",
        duration: 1500,
        isClosable: true,
      });
      return;
    }

    CrmDataService.updateCrmDataById(id, data)
      .then((response: any) => {
        func();
        onClose();
        toast({
          position: "top",
          title: "Note Updated Succesfully",
          status: "success",
          duration: 1000,
          isClosable: true,
        });
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{existingNote ? "Edit Note" : "Add Note"}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Textarea
            placeholder="Enter your note here..."
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color="white"
            mr={3}
            onClick={handleAddEditNote}
          >
            {existingNote ? "Update Note" : "Add Note"}
          </Button>
          {existingNote && (
            <Button
              bgColor="red"
              color="white"
              mr={3}
              onClick={handleDeleteNote}
            >
              Delete
            </Button>
          )}
          <Button bgColor="gray" color="white" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
